import { defaultPitch } from './pitch'
import { pitchSetupTypes } from '../../pitches/data_types'

export const canadianFootballProps = {
  reportMetricConfig: {
    playerPerformanceTable: {
      all: {
        metrics: {
          keys: []
        },
        eventMetricGroup: {
          eventTypes: [],
          groupName: {
            en: 'Success %',
            fr: 'Succès %'
          }
        }
      }
    },
    playerComparisonTable: {
      pass: {
        metrics: [[], [], []]
      }
    },
    monitoringCards: {
      technicalMetrics: [],
      physicalMetrics: []
    },
    dashboardMetrics: {
      performanceAgainstAverage: [],
      cardGrid: [[], []]
    }
  },
  pitch: {
    default: defaultPitch,
    defaultDoublePitch: null,
    pitchPointCount: 34,
    setupTypes: pitchSetupTypes,
    minPadding2D: 70,
    minPadding3D: 50,
    cameraYScale: 0.5,
    textureCanvasScale: 13,
    tenYardMarkings: 11,
    enableBench: true,
    defaultDrillRegion: {
      P1: 'P26',
      P2: 'P14',
      P3: 'P13',
      P4: 'P1',
      P5: null,
      P6: null,
      P7: null,
      P8: null
    } as const,
    drillsGoalsOrPosts: {
      enabled: false,
      dimensions: {
        large: {
          width: 7.32,
          height: 2.44,
          depth: 2.44
        },
        small: {
          width: 1.914,
          height: 1.914,
          depth: 1.61
        }
      }
    },
    drillSnapLines: [
      'P1',
      'P2',
      'P3',
      'P4',
      'P5',
      'P6',
      'P7',
      'P8',
      'P9',
      'P10',
      'P11',
      'P12',
      'P13',
      'P14',
      'P15'
    ],
    autosetupTagPositions: ['P8', 'P15', 'P17'],
    pitchCornerKeys: {
      topLeft: 'P30',
      topRight: 'P16',
      bottomRight: 'P15',
      bottomLeft: 'P1'
    },
    leftAutosetupRegion: {
      topLeft: 'P30',
      topRight: 'P23',
      bottomRight: 'P8',
      bottomLeft: 'P1'
    },
    rightAutosetupRegion: {
      topLeft: 'P23',
      topRight: 'P16',
      bottomRight: 'P15',
      bottomLeft: 'P8'
    },
    leftTeamRegion: {
      topLeft: 'P30',
      topRight: 'P29',
      bottomRight: 'P2',
      bottomLeft: 'P1'
    },
    rightTeamRegion: {
      topLeft: 'P17',
      topRight: 'P16',
      bottomRight: 'P15',
      bottomLeft: 'P14'
    }
  },
  features: {
    enablePromoteAllDevicesOnPitch: true,
    targetEvents: ['pass'],
    positionNumbers: false,
    maxPlayers: 100,
    defaultUnitSystem: 'Canadian',
    recentEventTableMetrics: [
      'inPitchDistance',
      'inPitchHangTime',
      'speed',
      'territorialGain'
    ],
    geniusAvailable: true,
    noOfPlayersInStartingLineUp: null,
    scoreboard: false,
    homeSideCheck: true,
    bibs: {},
    defaultBibTeamDirection: [] as number[]
  } as const
}

export const canadianFootballConfig = {
  key: 'canadianFootball' as const,
  value: 'CanadianFootball' as const,
  name: 'Canadian Football',
  props: canadianFootballProps
}
